import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { MailingFile } from '../models/MailingFile';

@Injectable({ providedIn: 'root' })

export class MailingFileService {
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/mailingfiles';
  }
 
  getAll(id: any): Observable<Array<MailingFile>> {
     return this.http.get<Array<MailingFile>>(this._ENDPOINT + '?mailingId=' + id );
  }

  getById(id: any): Observable<MailingFile> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<MailingFile>(url);
  }

  /** POST: add a new mailing to the server */
  add(mailingFile: MailingFile): Observable<MailingFile> {
    return this.http.post<MailingFile>(this._ENDPOINT, mailingFile, this.httpOptions).pipe(
      tap((newMailingFile: MailingFile) => this.log('added mailing w/ id=${newMailingFile.id}')),
      catchError(this.handleError<MailingFile>('add'))
    );
  }

  /** DELETE: delete the mailing from the server */
  delete(id: number): Observable<MailingFile> {
    
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<MailingFile>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted mailing file id=${id}')),
      catchError(this.handleError<MailingFile>('delete'))
    );
  }

  /** PUT: update the mailing on the server */
  update(id: number, mailingFile: MailingFile): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, mailingFile , this.httpOptions).pipe(
      tap(_ => this.log('updated mailing file id=${mailing.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a MailingFileService message with the MessageService */
  private log(message: string) {
    this.messageService.add('MailingFileService: ${message}');
  }
}
